import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  bottomSpacing: {
    paddingBottom: theme.spacing(2),
  },
  footerBttomSpacing: {
    paddingBottom: theme.spacing(3),
  },
  header: {
    marginBottom: theme.spacing(3),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  section: {
    '& header #section-actions': {
      opacity: 0.5,
      transition: `opacity ${theme.transitions.easing.easeIn}`,
      transitionDuration: `${theme.transitions.duration.shortest}ms`,
    },
    '&:hover': {
      '& header #section-actions': {
        opacity: 1,
      },
    },
  },
  table: {
    width: '100%',
    '& > tbody': {
      '& > tr': {
        '& > td': {
          width: '50%',
          maxWidth: 500,
          overflowWrap: 'break-word',
        },
      },
    },
    marginBottom: theme.spacing(2),
  },
  autoWidth: {},
}));

export default useStyles;
